import React, { useState, useEffect, useCallback } from 'react';
import { useTranslations } from '../ArticleFormNew/contexts/TranslationContext';

function getSteps(t) {
  return [
    { target: null, title: t.tour_welcome_title, description: t.tour_welcome_desc },
    { target: 'title_id', title: t.tour_title_title, description: t.tour_title_desc },
    { target: 'autosave', title: t.tour_autosave_title, description: t.tour_autosave_desc },
    { target: 'video_url', title: t.tour_video_url_title, description: t.tour_video_url_desc },
    { target: 'cover_image', title: t.tour_cover_title, description: t.tour_cover_desc },
    { target: 'content_tabs', title: t.tour_tabs_title, description: t.tour_tabs_desc },
    { target: 'editor', title: t.tour_editor_title, description: t.tour_editor_desc },
    { target: 'publish_panel', title: t.tour_publish_title, description: t.tour_publish_desc },
    { target: 'hospital_selector', title: t.tour_hospital_title, description: t.tour_hospital_desc },
    { target: 'tags_panel', title: t.tour_tags_title, description: t.tour_tags_desc },
    { target: 'categories_panel', title: t.tour_categories_title, description: t.tour_categories_desc },
    { target: 'seo_panel', title: t.tour_seo_title, description: t.tour_seo_desc },
    { target: 'classic_toggle', title: t.tour_classic_title, description: t.tour_classic_desc },
    { target: null, title: t.tour_done_title, description: t.tour_done_desc }
  ];
}

function VideoOnboardingTour({ onComplete, isOpen }) {
  var t = useTranslations();
  var steps = getSteps(t);

  var stepState = useState(0);
  var currentStep = stepState[0];
  var setCurrentStep = stepState[1];

  var rectState = useState(null);
  var targetRect = rectState[0];
  var setTargetRect = rectState[1];

  var step = steps[currentStep];
  var totalSteps = steps.length;
  var isFirst = currentStep === 0;
  var isLast = currentStep === totalSteps - 1;

  useEffect(function() {
    if (!isOpen || !step || !step.target) {
      setTargetRect(null);
      return;
    }
    var el = document.querySelector('[data-tour="' + step.target + '"]');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var timer = setTimeout(function() { setTargetRect(el.getBoundingClientRect()); }, 400);
      return function() { clearTimeout(timer); };
    } else {
      setTargetRect(null);
    }
  }, [isOpen, currentStep, step]);

  var handleNext = useCallback(function() {
    if (isLast) { onComplete(); } else { setCurrentStep(function(prev) { return prev + 1; }); }
  }, [isLast, onComplete]);

  if (!isOpen) return null;

  var padding = 8;
  var hasTarget = targetRect && step && step.target;

  var tooltipStyle = {};
  if (hasTarget) {
    var spaceBelow = window.innerHeight - targetRect.bottom;
    if (spaceBelow > 220) {
      tooltipStyle.top = (targetRect.bottom + padding + 8) + 'px';
    } else {
      tooltipStyle.top = Math.max(8, targetRect.top - padding - 220) + 'px';
    }
    tooltipStyle.left = Math.max(16, Math.min(targetRect.left, window.innerWidth - 360)) + 'px';
  }

  return (
    <div className="onboarding-tour">
      <div className="onboarding-tour__overlay" onClick={onComplete} />
      {hasTarget && (
        <div className="onboarding-tour__spotlight" style={{ top: (targetRect.top - padding) + 'px', left: (targetRect.left - padding) + 'px', width: (targetRect.width + padding * 2) + 'px', height: (targetRect.height + padding * 2) + 'px' }} />
      )}
      <div className={'onboarding-tour__tooltip' + (hasTarget ? '' : ' onboarding-tour__tooltip--centered')} style={hasTarget ? tooltipStyle : {}}>
        <h4>{step.title}</h4>
        <p>{step.description}</p>
        <div className="onboarding-tour__footer">
          <span className="onboarding-tour__steps">{currentStep + 1} / {totalSteps}</span>
          <div className="onboarding-tour__actions">
            {!isLast && <button type="button" className="btn btn-sm btn-link text-muted" onClick={onComplete}>{t.tour_skip}</button>}
            <button type="button" className="btn btn-sm btn-primary" onClick={handleNext}>{isLast ? t.tour_done : (isFirst ? t.tour_start : t.tour_next)}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VideoOnboardingTour;
